const { createRef, useRef } = require('react');

module.exports = function useFormInputRefs(formConfig) {

    const cachedRefs = useRef();

    if (!cachedRefs.current || cachedRefs.current.formConfig !== formConfig) {
        cachedRefs.current = {
            formConfig,
            inputRefs: typeof formConfig?.buildInputRefs === 'function'
                ? formConfig.buildInputRefs(createRef)
                : {}
        };
    }

    return cachedRefs.current.inputRefs;
};
